import { getEnvironment } from '@/helpers/environment';

let scriptAdded = false;

export const addScript = () => new Promise((resolve, reject) => {
  if (scriptAdded) {
    resolve();
    return;
  }

  const useProdCord = ['production', 'sandbox', 'test-app'].includes(getEnvironment());
  const staticPath = useProdCord ? 'cord' : 'cord-test';
  const url = `https://static.datapeople.io/${staticPath}/sdk/v1/sdk.latest.js`;

  const tag = document.createElement('script');
  tag.setAttribute('type', 'text/javascript');
  tag.setAttribute('src', url);
  tag.setAttribute('async', true);
  tag.setAttribute('defer', true);

  tag.onerror = () => {
    // an attempt to diagnose cord script load issues
    fetch(url, { mode: 'cors' })
      .then((response) => {
        reject(new Error(`${response.status} ${response.statusText}`));
      })
      .catch((error) => {
        reject(error);
      });
  };

  tag.onload = (event) => {
    scriptAdded = true;
    resolve(event);
  };

  document.head.appendChild(tag);

  // onload alternative. I'm not sure how well `onload` supported, so this check will resolve
  // the promise once the cord sdk script loaded with no corresponding `onload` event
  const interval = setInterval(() => {
    if (!scriptAdded && window.CordSDK) {
      clearInterval(interval);
      scriptAdded = true;
      resolve();
    }
  }, 500);
});

export const waitForCordSdk = async () => {
  if (window.CordSDK) {
    return window.CordSDK;
  }

  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (window.CordSDK) {
        clearInterval(interval);
        resolve(window.CordSDK);
      }
    }, 500);
  });
};

export const updateCordMessage = ({
  threadId, messageId, content, addAttachments = [],
} = {}) => window.CordSDK.thread.updateMessage(threadId, messageId, {
  content,
  addAttachments: addAttachments.map((id) => ({ type: 'file', id })),
});

export const getPostedCordMessage = (messageId) => new Promise((resolve) => {
  const ref = window.CordSDK.thread.observeMessage(messageId, (message) => {
    const messageHasContent = message?.content?.length > 0;
    const messageHasAttachments = message?.attachments?.length > 0;
    if (messageHasContent || messageHasAttachments) {
      // sometimes this callback get called even after unobserveMessage already called,
      // causing second unobserveMessage call throwing an exception
      try {
        window.CordSDK.thread.unobserveMessage(ref);
      } finally {
        resolve(message);
      }
    }
  });
});

export const uploadFileToCord = async ({ blob, name }) => {
  const { id } = await window.CordSDK.file.uploadFile({ name, blob });
  return id;
};
